export const diasNoviembre = {
      "originId": "54413",
      "destinationId": "100060000",
      "month": "12",
      "year": "2023",
      "currency": "EUR",
      "calendar": [
        {
            "day": "01",
            "minPrice": 0,
            "status": "disabled"
        },
        {
            "day": "02",
            "minPrice": 0,
            "status": "disabled"
        },
        {
            "day": "03",
            "minPrice": 0,
            "status": "disabled"
        },
        {
            "day": "04",
            "minPrice": 0,
            "status": "disabled"
        },
        {
            "day": "05",
            "minPrice": 0,
            "status": "disabled"
        },
        {
            "day": "06",
            "minPrice": 0,
            "status": "disabled"
        },
        {
            "day": "07",
            "minPrice": 0,
            "status": "disabled"
        },
        {
            "day": "08",
            "minPrice": 0,
            "status": "disabled"
        },
        {
            "day": "09",
            "minPrice": 0,
            "status": "disabled"
        },
        {
            "day": "10",
            "minPrice": 0,
            "status": "disabled"
        },
        {
            "day": "11",
            "minPrice": 0,
            "status": "disabled"
        },
        {
            "day": "12",
            "minPrice": 0,
            "status": "disabled"
        },
        {
            "day": "13",
            "minPrice": 0,
            "status": "disabled"
        },
        {
            "day": "14",
            "minPrice": 0,
            "status": "disabled"
        },
        {
            "day": "15",
            "minPrice": 0,
            "status": "disabled"
        },
        {
            "day": "16",
            "minPrice": 0,
            "status": "disabled"
        },
        {
            "day": "17",
            "minPrice": 0,
            "status": "disabled"
        },
        {
            "day": "18",
            "minPrice": 0,
            "status": "disabled"
        },
        {
            "day": "19",
            "minPrice": 0,
            "status": "disabled"
        },
        {
            "day": "20",
            "minPrice": 0,
            "status": "disabled"
        },
        {
            "day": "21",
            "minPrice": 0,
            "status": "disabled"
        },
        {
            "day": "22",
            "minPrice": 0,
            "status": "disabled"
        },
        {
            "day": "23",
            "minPrice": 0,
            "status": "disabled"
        },
        {
            "day": "24",
            "minPrice": 0,
            "status": "disabled"
        },
        {
            "day": "25",
            "minPrice": 0,
            "status": "disabled"
        },
        {
            "day": "26",
            "minPrice": 0,
            "status": "disabled"
        },
        {
            "day": "27",
            "minPrice": 0,
            "status": "disabled"
        },
        {
            "day": "28",
            "minPrice": 155,
            "status": "bestPrice"
        },
        {
            "day": "29",
            "minPrice": 0,
            "status": "enabled"
        },
        {
            "day": "30",
            "minPrice": 222,
            "status": "enabled"
        }
    ]
  
}

export const diasDiciembre = {
  "originId": "54413",
  "destinationId": "100060000",
  "month": "12",
  "year": "2023",
  "currency": "EUR",
  "calendar": [
      {
          "day": "01",
          "minPrice": 0,
          "status": "enabled"
      },
      {
          "day": "02",
          "minPrice": 0,
          "status": "enabled"
      },
      {
          "day": "03",
          "minPrice": 225,
          "status": "enabled"
      },
      {
          "day": "04",
          "minPrice": 0,
          "status": "enabled"
      },
      {
          "day": "05",
          "minPrice": 0,
          "status": "enabled"
      },
      {
          "day": "06",
          "minPrice": 0,
          "status": "enabled"
      },
      {
          "day": "07",
          "minPrice": 241,
          "status": "enabled"
      },
      {
          "day": "08",
          "minPrice": 0,
          "status": "enabled"
      },
      {
          "day": "09",
          "minPrice": 0,
          "status": "enabled"
      },
      {
          "day": "10",
          "minPrice": 725,
          "status": "enabled"
      },
      {
          "day": "11",
          "minPrice": 0,
          "status": "enabled"
      },
      {
          "day": "12",
          "minPrice": 0,
          "status": "enabled"
      },
      {
          "day": "13",
          "minPrice": 0,
          "status": "enabled"
      },
      {
          "day": "14",
          "minPrice": 0,
          "status": "enabled"
      },
      {
          "day": "15",
          "minPrice": 627,
          "status": "enabled"
      },
      {
          "day": "16",
          "minPrice": 0,
          "status": "enabled"
      },
      {
          "day": "17",
          "minPrice": 0,
          "status": "enabled"
      },
      {
          "day": "18",
          "minPrice": 447,
          "status": "enabled"
      },
      {
          "day": "19",
          "minPrice": 155,
          "status": "bestPrice"
      },
      {
          "day": "20",
          "minPrice": 155,
          "status": "bestPrice"
      },
      {
          "day": "21",
          "minPrice": 447,
          "status": "enabled"
      },
      {
          "day": "22",
          "minPrice": 155,
          "status": "bestPrice"
      },
      {
          "day": "23",
          "minPrice": 155,
          "status": "bestPrice"
      },
      {
          "day": "24",
          "minPrice": 447,
          "status": "enabled"
      },
      {
          "day": "25",
          "minPrice": 155,
          "status": "bestPrice"
      },
      {
          "day": "26",
          "minPrice": 115,
          "status": "bestPrice"
      },
      {
          "day": "27",
          "minPrice": 317,
          "status": "enabled"
      },
      {
          "day": "28",
          "minPrice": 155,
          "status": "bestPrice"
      },
      {
          "day": "29",
          "minPrice": 155,
          "status": "bestPrice"
      },
      {
          "day": "30",
          "minPrice": 222,
          "status": "enabled"
      },
      {
        "day": "31",
        "minPrice": 155,
        "status": "bestPrice"
    }
  ]

}
